var map = {
	"./01_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Modellfoto.jpg": 1026,
	"./02_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Grundriss-EG.jpg": 6246,
	"./03_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Grundriss-UG.jpg": 592,
	"./04_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Schnitt.jpg": 8121,
	"assets/b3_feasibilitystudy/01_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Modellfoto.jpg": 1026,
	"assets/b3_feasibilitystudy/02_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Grundriss-EG.jpg": 6246,
	"assets/b3_feasibilitystudy/03_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Grundriss-UG.jpg": 592,
	"assets/b3_feasibilitystudy/04_Prof.-Felix-Waechter_Machbarkeitsstudie-Mannheim_Schnitt.jpg": 8121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2259;